import { useEffect, useRef, useState } from 'react';

interface UseWorkoutProgressOptions {
  startedAt: number | null;
  estimatedDurationSeconds: number;
  isActive: boolean;
}

interface WorkoutProgress {
  elapsed: number;
  progress: number;
  percentage: number;
}

export function useWorkoutProgress({
  startedAt,
  estimatedDurationSeconds,
  isActive,
}: UseWorkoutProgressOptions): WorkoutProgress {
  const [elapsed, setElapsed] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>(0 as unknown as ReturnType<typeof setInterval>);

  useEffect(() => {
    if (!isActive || !startedAt || estimatedDurationSeconds <= 0) {
      setElapsed(0);
      return;
    }

    function tick() {
      setElapsed((Date.now() - startedAt!) / 1000);
    }

    tick();
    intervalRef.current = setInterval(tick, 1000);
    return () => clearInterval(intervalRef.current);
  }, [isActive, startedAt, estimatedDurationSeconds]);

  const progress = estimatedDurationSeconds > 0
    ? Math.min(1, elapsed / estimatedDurationSeconds)
    : 0;

  return {
    elapsed,
    progress,
    percentage: Math.round(progress * 100),
  };
}
